var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOperator(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 172 172",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,172v-172h172v172z",
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ff0f64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86,17.2112c-13.89187,0 -25.15052,8.36099 -25.15052,23.33646c0,6.3296 3.54974,11.2651 3.54974,11.2651c0,0 -1.6237,0.78296 -1.6237,4.16562c0,6.5704 4.22161,8.14089 4.22161,8.14089c0.59053,5.20013 8.67839,12.83281 8.67839,12.83281v8.68958c-4.34587,13.0376 -35.54219,4.44047 -35.54219,34.75833h91.73333c0,-30.41533 -31.19632,-21.72073 -35.54219,-34.75833v-8.68958c0,0 8.08785,-7.63268 8.67839,-12.83281c0,0 4.22161,-2.91782 4.22161,-8.14089c0,-3.62347 -1.6237,-4.16562 -1.6237,-4.16562c0,0 2.91146,-5.52039 2.91146,-10.78359c0,-10.54933 -5.29536,-18.66693 -14.18776,-18.66693c0,0 -3.78274,-5.15104 -10.32448,-5.15104zM34.84792,131.86667l-7.79375,6.51719c-1.31373,-0.51245 -2.71071,-0.77818 -4.12083,-0.78386c-6.33287,0 -11.46667,5.1338 -11.46667,11.46667c0,6.33287 5.1338,11.46667 11.46667,11.46667c6.33287,0 11.46667,-5.1338 11.46667,-11.46667c-0.00331,-0.58889 -0.05198,-1.17666 -0.14557,-1.75808l18.46536,-15.44192zM80.26667,131.86667v18.75651c-3.54154,2.0447 -5.7261,5.82076 -5.73333,9.91016c0,6.33287 5.1338,11.46667 11.46667,11.46667c6.33287,0 11.46667,-5.1338 11.46667,-11.46667c-0.00324,-4.09341 -2.18834,-7.87465 -5.73333,-9.92136v-18.74531zM119.28021,131.86667l18.46536,15.44192c-0.0936,0.58142 -0.14227,1.16918 -0.14558,1.75808c0,6.33287 5.1338,11.46667 11.46667,11.46667c6.33287,0 11.46667,-5.1338 11.46667,-11.46667c0,-6.33287 -5.1338,-11.46667 -11.46667,-11.46667c-1.41319,0.00073 -2.81407,0.26268 -4.13203,0.77266l-7.78255,-6.50599z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOperator);
export default __webpack_public_path__ + "static/media/operator.d5fad66ed9d8030340ee3319f4343b96.svg";
export { ForwardRef as ReactComponent };